"use client";

import { appConfig } from "@/config";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

export type LogoProps = {
  className?: string;
  href?: string;
};

export default function Logo({ className, href }: LogoProps) {
  const [isDarkMode, setIsDarkMode] = useState<boolean | undefined>();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return (
    <Link
      href={href || "/"}
      className="flex items-center gap-1 leading-none cursor-pointer !no-underline !text-black dark:!text-white"
    >
      <Image
        src={isDarkMode ? "/assets/logo-white.svg" : "/assets/logo-black.svg"}
        alt={"Logo"}
        width={48} // Set width equal to height for square logo
        height={48} // Set height (12 * 4px)
        style={{ height: "48px", width: "auto" }} // Override width to auto
      />
      <span className={`${className}`}>{appConfig.name}</span>
    </Link>
  );
}
